import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header className="fixed top-0 left-0 w-full z-50">
      <div
        className={`w-full overflow-hidden transition-all duration-300 bg-primary-950 ${scrolled ? 'max-h-0 opacity-0' : 'max-h-12 opacity-100'}`}
      >
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 h-10 flex items-center gap-3 text-[13px] text-background-100">
          <span className="inline-flex items-center gap-1.5 text-accent-300 whitespace-nowrap">
            <i className="ri-flashlight-fill" /> 站内快讯
          </span>
          <span className="hidden sm:inline text-background-200/80">公共区今日已更新 128 条新料，讨论群 46 个正在开聊</span>
          <span className="ml-auto inline-flex items-center gap-1.5 text-background-200/80 whitespace-nowrap">
            <i className="ri-group-line" /> 3,482 人在线
          </span>
        </div>
      </div>

      <div
        className={`w-full transition-colors duration-300 border-b ${
          solid ? 'bg-background-50/95 backdrop-blur border-background-200' : 'bg-transparent border-transparent'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 h-16 md:h-[72px] flex items-center gap-4 md:gap-10">
          <a href="#top" className={`flex items-center gap-2.5 whitespace-nowrap ${solid ? 'text-foreground-950' : 'text-background-50'}`}>
            <span className={`w-9 h-9 rounded-md flex items-center justify-center ${solid ? 'bg-primary-500 text-background-50' : 'bg-accent-500 text-foreground-950'}`}>
              <i className="ri-fire-fill text-lg" />
            </span>
            <span className="font-heading text-lg md:text-xl font-bold tracking-wide">黑料网社</span>
          </a>

          <nav className="hidden lg:flex items-center gap-7 text-sm font-medium">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`whitespace-nowrap transition-colors ${
                  solid ? 'text-foreground-700 hover:text-primary-600' : 'text-background-100 hover:text-accent-300'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="ml-auto hidden md:flex items-center gap-3">
            <label
              className={`flex items-center gap-2 h-10 px-4 rounded-full border transition-colors ${
                solid ? 'bg-background-100 border-background-300 text-foreground-600' : 'bg-background-50/15 border-background-50/30 text-background-100'
              }`}
            >
              <i className="ri-search-line text-base" />
              <input
                type="text"
                placeholder="搜话题 / 老哥 / 新料"
                className={`bg-transparent outline-none text-sm w-40 xl:w-52 placeholder:opacity-70 ${solid ? 'text-foreground-900' : 'text-background-50'}`}
              />
            </label>
            <a
              href="#download"
              className="h-10 px-5 rounded-full bg-accent-500 text-foreground-950 text-sm font-bold flex items-center gap-1.5 whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
            >
              <i className="ri-download-2-line" /> 下载入口
            </a>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md border cursor-pointer ${
              solid ? 'border-background-300 text-foreground-900' : 'border-background-50/30 text-background-50'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>

        {menuOpen && (
          <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 px-2 text-sm font-medium text-foreground-800 border-b border-background-200/70 last:border-0"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#download"
              onClick={() => setMenuOpen(false)}
              className="mt-3 h-11 rounded-full bg-accent-500 text-foreground-950 text-sm font-bold flex items-center justify-center gap-1.5 whitespace-nowrap"
            >
              <i className="ri-download-2-line" /> 下载入口
            </a>
          </div>
        )}
      </div>
    </header>
  );
}